module.exports = __webpack_public_path__ + "static/media/logo.c1f08c9c.png";